module.exports = __webpack_public_path__ + "img/score2.3636395f.png";